import type { DeepPartial } from "@slfinrtl/ui-bff-routes"
import { dequal } from "dequal/lite"

/**
 *
 * @param obj1
 * @param obj2
 * @returns an object containing every attribute of obj1 that has changed compared to obj2. If the objects are equal, return undefined
 */

export const getDifference = <T extends object>(obj1: T, obj2: T): DeepPartial<T> | T | undefined => {
	if (Array.isArray(obj1)) {
		return dequal(obj1, obj2) ? undefined : obj1
	}
	const result = Object.keys(obj1).reduce((acc, key) => {
		const value1 = (obj1 as any)[key]
		const value2 = (obj2 as any)[key]
		if (value1 !== null && typeof value1 === "object" && value2 !== null && typeof value2 === "object") {
			const diff = getDifference(value1, value2)
			if (diff) {
				acc[key] = diff
			}
			return acc
		}
		if (value1 !== value2) {
			acc[key] = value1
		}
		return acc
	}, {} as any)
	return dequal(result, {}) ? undefined : result
}
